var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showNoIcon,
          expression: "showNoIcon",
        },
      ],
      attrs: { role: "main" },
    },
    [
      _c("div", { staticClass: "container padding-y-4xl" }, [
        _c(
          "article",
          { staticClass: "card roomy" },
          [
            _c("font-awesome-icon", {
              staticStyle: {
                "--fa-secondary-opacity": "1",
                "--fa-secondary-color": "var(--fa-yellow)",
              },
              attrs: { icon: _vm.$v6.duotone.faFaceThinking, size: "4x" },
            }),
            _vm._v(" "),
            _c("h1", { staticClass: "margin-y-2xs" }, [
              _vm._v("An icon named “" + _vm._s(_vm.iconName) + "”?!"),
            ]),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "size-lg line-length-lg margin-auto" },
              [
                _vm._v("\n        We don't have that in\n        "),
                _c(
                  "site-link",
                  {
                    attrs: { to: _vm.$search() },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("icon_search_link_click", {
                          context: "icon_not_found_view",
                        })
                      },
                    },
                  },
                  [
                    _vm._v(
                      "our collection of " +
                        _vm._s(_vm.$counts.icons.all.formatted) +
                        " icons"
                    ),
                  ]
                ),
                _vm._v(
                  ". You may have typed the address (URL) incorrectly – check to make sure you've got the exact spelling.\n      "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("input-term", {
              staticClass: "line-length-md padding-y-lg margin-auto",
              attrs: {
                term: _vm.term,
                "is-showing-go-button": !!_vm.term,
                label: `Search the v${_vm.$releases.active.versionParts.major} Icons`,
              },
              on: {
                input: (newTerm) => (_vm.term = newTerm),
                go: (term) => _vm.$router.push(_vm.$search({ term })),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "row roomy align-stretch margin-y-4xl",
            attrs: { id: "options" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "column-12 margin-bottom-2xl tablet:column-6 laptop:margin-bottom-0 laptop:column-3",
              },
              [
                _c(
                  "article",
                  {
                    staticClass: "card roomy red",
                    staticStyle: { height: "100%" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("wa-question-mark-block", {
                          attrs: {
                            "block-size": "4x",
                            "block-color": "var(--text-color)",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section text-left padding-bottom-0" },
                      [
                        _c("h2", { staticClass: "h5" }, [
                          _vm._v("Did We Do That???"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "laptop:size-sm" }, [
                          _vm._v(
                            "\n              Think you followed a broken link or “" +
                              _vm._s(_vm.iconName) +
                              "” existed previously but disappeared?\n              "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "mailto:hello@fontawesome.com?subject=I found a broken link or missing icon, Font Awesome",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.supportLinkClicked(
                                    "icon_not_found_view"
                                  )
                                },
                              },
                            },
                            [_vm._v("Let us know")]
                          ),
                          _vm._v(".\n            "),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column-12 margin-bottom-2xl tablet:column-6 laptop:margin-bottom-0 laptop:column-3",
              },
              [
                _c(
                  "site-link",
                  {
                    staticClass: "card roomy yellow",
                    staticStyle: { height: "100%" },
                    attrs: { to: _vm.$docs("/web/add-icons/icon-wizard") },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("icons_wizard_link_click", {
                          context: "icon_not_found_view",
                        })
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faSquareDashedCirclePlus,
                            "fixed-width": "",
                            size: "4x",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section text-left padding-bottom-0" },
                      [
                        _c("h2", { staticClass: "h5" }, [
                          _vm._v("Use the Icon Wizard"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "laptop:size-sm" }, [
                          _vm._v(
                            "You can add a modifier to any icon with our Icon Wizard. Give it a try!"
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column-12 margin-bottom-2xl tablet:column-6 laptop:margin-bottom-0 laptop:column-3",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "card roomy blue",
                    staticStyle: { height: "100%" },
                    attrs: {
                      href: "https://fontawesome.com/leaderboard/new#request",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture(
                          "icon_requests_leaderboard_link_click",
                          { context: "icon_not_found_view" }
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faMessageQuestion,
                            "fixed-width": "",
                            size: "4x",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section text-left padding-bottom-0" },
                      [
                        _c("h2", { staticClass: "h5" }, [
                          _vm._v("Request an Icon"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "laptop:size-sm" },
                          [
                            _vm._v(
                              "\n              Suggest " +
                                _vm._s(_vm.iconName) +
                                " to our community and vote it up the ranks of our\n              "
                            ),
                            _c(
                              "site-link",
                              { attrs: { to: { name: "leaderboard.new" } } },
                              [_vm._v("Icon Requests Leaderboard")]
                            ),
                            _vm._v("\n              .\n            "),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "column-12 margin-bottom-2xl tablet:column-6 laptop:margin-bottom-0 laptop:column-3",
              },
              [
                _c(
                  "site-link",
                  {
                    staticClass: "card roomy teal",
                    staticStyle: { height: "100%" },
                    attrs: { to: _vm.$docs("/web/add-icons/upload-icons") },
                    on: {
                      click: function ($event) {
                        return _vm.$posthog.capture(
                          "docs_upload_icons_link_click",
                          { context: "icon_not_found_view" }
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "header" },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v6.solid.faCloudArrowUp,
                            "fixed-width": "",
                            size: "4x",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section text-left padding-bottom-0" },
                      [
                        _c("h2", { staticClass: "h5" }, [
                          _vm._v("Upload an Icon"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "laptop:size-sm" }, [
                          _vm._v(
                            "Upload your own " +
                              _vm._s(_vm.iconName) +
                              " icon to a kit and easily use it just like it an official Font Awesome icon!"
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          { attrs: { id: "new-in-v6" } },
          [
            _c("div", { staticClass: "text-center margin-bottom-2xl" }, [
              _c("h2", { staticClass: "h3" }, [_vm._v("Might We Suggest…")]),
              _vm._v(" "),
              _c("p", { staticClass: "size-lg line-length-lg margin-auto" }, [
                _vm._v(
                  "Here are some icons that do exist in Font Awesome " +
                    _vm._s(_vm.$releases.active.versionParts.major) +
                    "."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "ais-instant-search",
              {
                attrs: {
                  "search-client": _vm.searchClient,
                  "index-name": _vm.index,
                },
              },
              [
                _c("ais-configure", {
                  attrs: {
                    hitsPerPage: 240,
                    distinct: true,
                    facetFilters: _vm.facetFilters(),
                  },
                }),
                _vm._v(" "),
                _c("ais-hits", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ items }) {
                        return _c(
                          "div",
                          {
                            class: `icon-listing ${_vm.resultsView}`,
                            attrs: { id: "icons-listing" },
                          },
                          _vm._l(items, function (item) {
                            return _c("icon-link", {
                              key: item.objectID,
                              attrs: {
                                icon: item,
                                "results-view": _vm.resultsView,
                                version: _vm.version,
                              },
                            })
                          }),
                          1
                        )
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }